var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('activator',{attrs:{"placeholder":"ابحث عن سؤال","btnText":"سؤال جديد"},on:{"search":_vm.search,"ok":_vm.navigateToCreateQuestion}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }